export default __webpack_public_path__ + "assets/community-three-two.ce5e7a6f162c174d64a9965aafc41fa4.png";